import { Box, Details, Icon, TextLink, useOpenClose } from '@palmetto/palmetto-components';

import { AccountStipulationReason, AccountStipulationType } from 'types';

import { stipulationTypeToLabel } from '../../Account/PauseBanner';
import RequirePalmettoFinanceUser from '../../auth/RequirePalmettoFinanceUser';

import EventBy from './EventBy';

interface StipulationDetailsProps {
  reason: string;
  isOpen: boolean;
  handleToggle: () => void;
  isSatisfied: boolean;
  isSatisfiedNote?: string;
  description?: string;
  recheckCallUrl?: string;
}
const StipulationDetails: React.FC<StipulationDetailsProps> = ({
  reason,
  isOpen,
  handleToggle,
  isSatisfied,
  isSatisfiedNote,
  description,
  recheckCallUrl,
}: StipulationDetailsProps) => (
  <Details
    isOpen={isOpen}
    margin="xs 0 0 0"
    display="block"
    background="primary"
    radius="md"
    borderWidth="xs"
    borderColor="separator"
    width="100"
  >
    <Details.Summary
      isDetailsOpen={isOpen}
      onToggle={handleToggle}
      justifyContent="space-between"
      display="flex"
      direction="row"
      alignItems="center"
      padding="md"
    >
      <Box>{reason}</Box>
      <Box fontSize="xs" direction="row" alignItems="center" childGap="xs" hover={{ color: 'body-primary' }}>
        <Icon name={isOpen ? 'caret-up' : 'caret-down'} />
      </Box>
    </Details.Summary>
    <Box padding="md" childGap="sm" borderWidth="xs 0 0 0" borderColor="separator">
      <Box display="block" childGap="xs">
        {isSatisfiedNote && (
          <Box display="block" childGap="xs">
            <Box as="span" fontWeight="bold">
              Satisfied Note:
            </Box>
            <Box as="div">{isSatisfiedNote}</Box>
            {recheckCallUrl && (
              <RequirePalmettoFinanceUser>
                <Box as="div">
                  <TextLink href={recheckCallUrl} target="_blank" rel="noopener noreferrer">
                    View Recheck call
                  </TextLink>
                </Box>
              </RequirePalmettoFinanceUser>
            )}
          </Box>
        )}
        {!isSatisfied && description && (
          <Box display="block" childGap="xs">
            <Box as="span" fontWeight="bold">
              Description:
            </Box>
            <Box as="div">{description}</Box>
          </Box>
        )}
      </Box>
    </Box>
  </Details>
);

const AccountStipulation = ({ event }: { event: any }) => {
  const { isOpen, handleToggle } = useOpenClose();
  const eventData = event?.data || {};
  const { isSatisfied = false, stipulationType, description, reason, isSatisfiedNote, recheckCallUrl } = eventData;

  const type = stipulationType as AccountStipulationType;
  const shouldShowDetails = (reason && description) || (reason && isSatisfiedNote);
  const stipulationLabel = stipulationTypeToLabel[type]?.toLowerCase() || '';
  const isWelcomeCall = reason === AccountStipulationReason.welcomeCall;
  const reasonText = reason === 'Age Related' ? 'Customer Action Required' : reason;

  return (
    <Box display="block" childGap="sm">
      <Box display="block">
        <Box as="span" display="inline-block" margin="0 2xs 0 0" childGap="md">
          <EventBy event={event} /> {isSatisfied ? 'cleared' : 'flagged'} {stipulationLabel}
        </Box>
      </Box>

      {shouldShowDetails && (
        <StipulationDetails
          reason={reasonText}
          isOpen={isOpen}
          handleToggle={handleToggle}
          isSatisfied={isSatisfied}
          isSatisfiedNote={isSatisfiedNote}
          description={description}
          recheckCallUrl={isWelcomeCall ? recheckCallUrl : undefined}
        />
      )}
    </Box>
  );
};

export default AccountStipulation;
